/**
 * @enum {number}
 */
const EAuthStrategy = {
    classic: 1,
    google: 2,
}

export default EAuthStrategy
